import React, { useState } from 'react';
import { JRCButton } from '../../JRCButton/JRCButton';

export const EntityItemSelection = ({ title, onClick }: { title: string; onClick: (isSelected: boolean) => void }) => {
    const [isSelected, setIsSelected] = useState<boolean>(false);

    return (
        <JRCButton
            onClick={() => {
                setIsSelected(!isSelected);
                onClick(!isSelected);
            }}
            color={'secondary'}
            variant={!isSelected ? 'outlined' : 'contained'}
            minWidth={'200px'}>
            {title}
        </JRCButton>
    );
};
